import { ref } from 'vue';

export const leftWidth = ref(60);
export const changeWidth = (val: number) => {
  leftWidth.value = val;
};
